import type { RealWedding } from '../types/landing'

export const realWeddings: RealWedding[] = [
  {
    tag: 'Magic Everywhere',
    couple: 'Ariana & Tracy',
    description:
      'This adventurous couple put friends, family, and fun first when planning their dream day.',
    image: 'https://cdn.magicpatterns.com/uploads/6qQMcPaGqYhxqde3CVu97T/Screenshot_2026-09-30_at_9.22.06_AM.png',
  },
  {
    tag: 'Moody fall wedding',
    couple: 'McKenna & Luke',
    description:
      'A dream wedding weekend in the mountains, framed by the rich colors of fall.',
    image: 'https://cdn.magicpatterns.com/uploads/vN15RgRrgsrFvs4hepj7JZ/20241026_McKenna_Moody_and_Luke_Cadona_-_Sneek_Peaks_-_Peyton_Rainey_Photography00072.jpg',
  },
  {
    tag: 'A whimsical dream',
    couple: 'Sarah & Cory',
    description:
      'Their wedding day was a whimsical, dream come true experience, where every detail fell perfectly into place.',
    image: 'https://cdn.magicpatterns.com/uploads/xpN6o9kuHBucTZzt2ouCdw/sarah__cory.webp',
  },
]
